import React from 'react';
import './innercss.css'
import { aaplesarkar, Cidco, digitalindia, India, india111, maharashtra, makeinindia, mfs, NMMRDA, NMMRDA111, NNgMRDA, NNMRDA, NPMRDA } from '../../../public/LoginImages/importimages';

const ContactUS = () => {
    return (
        <div >
            <div style={{ display: 'flex', justifyContent: 'space-evenly', padding: '10px',flexWrap:'wrap' }}>
                <div className='col-8' style={{ display: 'grid', alignItems: 'center', width: '54rem',overflow:'auto' }}>
                    <h1 style={{ display: 'flex', justifyContent: 'center', fontWeight: '700' }}>अधिकारी व दूरध्वनी</h1>
                    <div style={{ backgroundColor: '#ccd9cc' }}>
                        <table >
                            <tbody>
                                <tr>
                                    <td style={{ width: '2rem' }}>&nbsp;</td>
                                    <td><strong>अधिकाऱ्यांचे नाव</strong></td>
                                    <td><strong>हुद्दा</strong></td>
                                    <td><strong>बैठक व्यवस्था</strong></td>
                                    <td><strong>दूरध्वनी</strong></td>
                                    <td><strong>विस्तारीत क्रमांक</strong></td>
                                </tr>
                                <tr>
                                    <td>1</td>
                                    <td>श्री. भूषण गगराणी</td>
                                    <td>अपर मुख्य सचिव (नवि-1)</td>
                                    <td>4 था मजला, मंत्रालय (मुख्य)</td>
                                    <td>022-22026419 022-22026258</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>2</td>
                                    <td>श्रीम. सोनिया सेठी</td>
                                    <td>प्रधान सचिव (नवि-2)</td>
                                    <td>4 था मजला, मंत्रालय (मुख्य)</td>
                                    <td>022-22021444 022-22824111</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>3</td>
                                    <td>श्री. सु.ना.शिंदे</td>
                                    <td>सहसचिव</td>
                                    <td>4 था मजला, मंत्रालय (विस्तार) दालन क्र. 21</td>
                                    <td>022-22821312</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>4</td>
                                    <td>श्रीम. प्रतिभा भदाणे</td>
                                    <td>संचालक, नगर रचना तथा सह सचिव</td>
                                    <td>4 था मजला, मंत्रालय (मुख्य) दालन क्र.2</td>
                                    <td>022-22026307</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>5</td>
                                    <td>श्री. सु.प्र.मरळे&nbsp;</td>
                                    <td>सह संचालक, नगर रचना तथा सह सचिव&nbsp;</td>
                                    <td>4 था मजला, मंत्रालय (मुख्य) दालन क्र.5</td>
                                    <td>022-22820511</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>6</td>
                                    <td>श्री. कैलास बधान&nbsp;</td>
                                    <td>उप सचिव</td>
                                    <td>4 था मजला, मंत्रालय (मुख्य) दालन क्र.6</td>
                                    <td>022-22830658</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>7</td>
                                    <td>श्री. शंकर त्र्यं.जाधव&nbsp;</td>
                                    <td>उप सचिव</td>
                                    <td>4 था मजला, मंत्रालय (मुख्य) दालन क्र.7</td>
                                    <td>022-22820460</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>8</td>
                                    <td>श्री. विजय चौधरी</td>
                                    <td>उप सचिव</td>
                                    <td>4 था मजला, मंत्रालय (मुख्य) दालन क्र.1</td>
                                    <td>022-22854573 022<br />-22793497</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>9</td>
                                    <td>श्रीम. विद्या हम्पय्या</td>
                                    <td>उप सचिव</td>
                                    <td>4 था मजला, मंत्रालय (मुख्य) दालन क्र.8</td>
                                    <td>022-22830658    </td>
                                    <td>21</td>
                                </tr>
                                <tr>
                                    <td>10</td>
                                    <td>	श्रीम. प्रियांका कुलकर्णी -छापवाले</td>
                                    <td>उप सचिव</td>
                                    <td>4 था मजला, मंत्रालय (मुख्य)<br /> दालन क्र.9</td>
                                    <td>022-22846757</td>
                                    <td>20</td>
                                </tr>
                                <tr>
                                    <td>11</td>
                                    <td>श्री. श्रीकांत चं.आंडगे</td>
                                    <td>उप सचिव</td>
                                    <td>4 था मजला, मंत्रालय (मुख्य)<br /> दालन क्र.10</td>
                                    <td>022-22838878</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>12</td>
                                    <td>श्री. अनिरुध्द व्यं.जेवळीकर</td>
                                    <td>उप सचिव</td>
                                    <td>4 था मजला, मंत्रालय (मुख्य)<br /> दालन क्र.19</td>
                                    <td>022-22820447</td>
                                    <td>23</td>
                                </tr>
                                <tr>
                                    <td>13</td>
                                    <td>श्री. अजयसिंग पाटील</td>
                                    <td>अवर सचिव(नवि-7,27)</td>
                                    <td>4 था मजला, मंत्रालय (मुख्य)</td>
                                    <td>022-22794200</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>14</td>
                                    <td>श्री. नवनाथ वाठ</td>
                                    <td>अवर सचिव (नवि-4,16)</td>
                                    <td>4 था मजला, मंत्रालय (मुख्य)</td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>15</td>
                                    <td>श्री. प्रितमकुमार जावळे</td>
                                    <td>अवर सचिव (नवि-15)</td>
                                    <td>3 रा मजला, मंत्रालय (मुख्य)</td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>16</td>
                                    <td>श्री. अ.शा.मुत्याल</td>
                                    <td>अवर सचिव( नवि-21)</td>
                                    <td>4 था मजला, मंत्रालय (मुख्य)</td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>17</td>
                                    <td>श्रीम. निकेता पांडे</td>
                                    <td>अवर सचिव (नवि-23)</td>
                                    <td>4 था मजला, मंत्रालय (मुख्य)</td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>18</td>
                                    <td>श्रीम. वीणा मोरे</td>
                                    <td>अवर सचिव (नवि-30)</td>
                                    <td>4 था मजला, मंत्रालय (मुख्य)</td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>19</td>
                                    <td>श्री. समाधान व. खटकाळे</td>
                                    <td>अवर सचिव (नवि-3,8,10,29, नाजकधा)</td>
                                    <td>4 था मजला, मंत्रालय (मुख्य)</td>
                                    <td>022-22794195</td>
                                    <td>4192</td>
                                </tr>
                                <tr>
                                    <td>20</td>
                                    <td>श्री. अशोक लक्कस</td>
                                    <td>अवर सचिव (नवि-14)</td>
                                    <td>4 था मजला, मंत्रालय (मुख्य)</td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>21</td>
                                    <td>श्रीम. प्रतिभा मा.पाटील</td>
                                    <td>अवर सचिव (नवि-28)</td>
                                    <td>4 था मजला, मंत्रालय (मुख्य)</td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>22</td>
                                    <td>श्री. सु.ह.भजनावळे</td>
                                    <td>अवर सचिव (नवि-06)</td>
                                    <td>4 था मजला, मंत्रालय (मुख्य)</td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>23</td>
                                    <td>श्री. किसन धों. निकम</td>
                                    <td>अवर सचिव (नवि-24)</td>
                                    <td></td>
                                    <td></td>
                                    <td>-</td>
                                </tr>
                                <tr>
                                    <td>24</td>
                                    <td>श्री. निर्मलकुमार चौधरी</td>
                                    <td>सहा. संचालक, नगर रचना तथा अवर सचिव&nbsp; (नवि-11)</td>
                                    <td>4 था मजला, मंत्रालय (मुख्य)</td>
                                    <td>-</td>
                                    <td>-</td>
                                </tr>
                                <tr><td>25</td><td>श्री. किशोर गोखले</td><td>सहा. संचालक नगर रचना, तथा अवर सचिव&nbsp; (नवि-13)</td><td>4 था मजला, मंत्रालय (मुख्य) दालन क्र.2</td><td>022-22794196</td><td>4196</td></tr>
                                <tr><td>26</td><td>श्रीम. वर्षा साखरे</td><td>अवर सचिव (विधी)</td><td>3 रा मजला, मंत्रालय (मुख्य)</td><td>022-22838875</td><td>-</td></tr>
                                <tr><td>27</td><td>श्री. नितीन शेळके&nbsp; (अति. कार्य.)</td><td>कक्ष अधिकारी (नवि-3)</td><td>4 था मजला, मंत्रालय (मुख्य)</td><td>022-22820455</td><td>-</td></tr>
                                <tr><td>28</td><td>श्री. म.प.दळवी</td><td>कक्ष अधिकारी (नवि-4)</td><td>4 था मजला, मंत्रालय (मुख्य)</td><td>022-22793837</td><td>-</td></tr>
                                <tr><td>29</td><td>श्री. रा.सु.वडनेरकर, (अति. कार्य.)</td><td>कक्ष अधिकारी (नवि-5)</td><td>4 था मजला, मंत्रालय (मुख्य)</td><td>022-22855468</td><td>-</td></tr>
                                <tr><td>30</td><td>&nbsp;</td><td>कक्ष अधिकारी (नवि-7)</td><td>4 था मजला, मंत्रालय (मुख्य)</td><td>-</td><td>-</td></tr>
                                <tr><td>31</td><td>श्री. शिरीष स.पाटील</td><td>कक्ष अधिकारी (नवि-7)</td><td>4 था मजला, मंत्रालय (मुख्य)</td><td>-</td><td>-</td></tr>
                                <tr><td>32</td><td>श्री. रा.सु.वडनेरकर, (अति. कार्य.)</td><td>कक्ष अधिकारी (नवि-8)</td><td>4 था मजला, मंत्रालय (मुख्य)</td><td>022-22855468</td><td>-</td></tr>
                                <tr><td>33</td><td>श्री. देवदत्त राहाणे</td><td>कक्ष़ अधिकारी (नवि-9)</td><td>4 था मजला, मंत्रालय (मुख्य)</td><td>-</td><td>-</td></tr>
                                <tr><td>34</td><td>श्री. लक्ष्मीकांत जाधव</td><td>कक्ष़ अधिकारी (नवि-10)</td><td>4 था मजला, मंत्रालय (मुख्य)</td><td>022-22820455</td><td>-</td></tr>
                                <tr><td>35</td><td>श्री. पुरुषोत्तम शिंदे</td><td>कक्ष्‍ा अधिकारी (नवि-12)</td><td>4 था मजला, मंत्रालय (मुख्य)</td><td>-</td><td>-</td></tr>
                                <tr><td>36</td><td>श्री. महेश गु. हंशेट्टी</td><td>कक्ष्‍ा अधिकारी (नवि-15)</td><td>3 रा मजला, मंत्रालय (मुख्य)</td><td>-</td><td>-</td></tr>
                                <tr><td>37</td><td>श्री. शरद किरवले</td><td>कक्ष्‍ा अधिकारी (नवि-16)</td><td>4 था मजला, मंत्रालय (मुख्य)</td><td>-</td><td>-</td></tr>
                                <tr><td>38</td><td>रिक्त&nbsp;</td><td>कक्ष अधिकारी (नवि-17)&nbsp;&nbsp;</td><td>-</td><td>-</td><td>-</td></tr>
                                <tr><td>39</td><td>श्री. वि.ना.धाईजे</td><td>कक्ष अधिकारी (नवि-18)</td><td>4 था मजला, मंत्रालय (मुख्य)</td><td>-</td><td>4207</td></tr>
                                <tr><td>40</td><td>श्री. रश्मीकांत इंगोले</td><td>कक्ष अधिकारी (नवि-19)</td><td>4 था मजला, मंत्रालय (मुख्य)</td><td>-</td><td>-</td></tr>
                                <tr><td>41</td><td>श्री. मोहसीन बागवान, (अति. कार्य.)</td><td>कक्ष अधिकारी (नवि-20)</td><td>4 था मजला, मंत्रालय (मुख्य)</td><td>-</td><td>-</td></tr>
                                <tr><td>42</td><td>श्री. अविनाश शितोळे</td><td>कक्ष अधिकारी (नवि-21)</td><td>4 था मजला, मंत्रालय(मुख्य)</td><td>022-22025973</td><td>-</td></tr>
                                <tr><td>43</td><td>श्री. शिवाजी बा. चव्हाण</td><td>कक्ष अधिकारी (नवि-22)</td><td>4 था मजला, मंत्रालय (मुख्य)</td><td>-</td><td>4207</td></tr>
                                <tr><td>44</td><td>श्री. मोहसीन बागवान</td><td>कक्ष अधिकारी (नवि-25)</td><td>4 था मजला, मंत्रालय (मुख्य)</td><td>-</td><td>-</td></tr>
                                <tr><td>45</td><td>श्री. धनंजय ल.भागवत</td><td>कक्ष अधिकारी (नवि-26)</td><td>4 था मजला, मंत्रालय (मुख्य)</td><td>022-22794206</td><td>-</td></tr>
                                <tr><td>46</td><td>श्री. नितीन शेळके</td><td>कक्ष अधिकारी (नवि-27)</td><td>4 था मजला, मंत्रालय (मुख्य)</td><td>-</td><td>-</td></tr>
                                <tr><td>47</td><td>श्री. रा.सु.वडनेरकर</td><td>कक्ष अधिकारी (नवि-29)</td><td>4 था मजला, मंत्रालय (मुख्य)</td><td>022-22855468</td><td>-</td></tr>
                                <tr><td>48</td><td>श्रीम. श्रिया देसाई</td><td>लेखाधिकारी (नवि-31)</td><td>नवीन प्रशासकीय इमारत, 16 वा मजला</td><td>-</td><td>-</td></tr>
                                <tr><td>49</td><td>रिक्त</td><td>कक्ष अधिकारी (नवि-32)</td><td>4 था मजला, मंत्रालय (विस्तार) दालन क्र. 21</td><td>-</td><td>-</td></tr>
                                <tr><td>50</td><td>श्री. गजानन द.आलेवाड</td><td>कक्ष अधिकारी (नवि-33)</td><td>4 था मजला, मंत्रालय (मुख्य)</td><td>-</td><td>-</td></tr>
                                <tr><td>51</td><td>श्री. अजित सा.पालवे</td><td>कक्ष अधिकारी (नवि-34)</td><td>3 रा मजला, मंत्रालय (मुख्य)</td><td>-</td><td>-</td></tr>
                                <tr><td>52</td><td>श्री. रा.अ.साबणे</td><td>कक्ष अधिकारी (नाजकधा)</td><td>नवीन प्रशासकीय इमारत 16 वा मजला</td><td>022-22794195</td><td>-</td></tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col-4">

                    <div style={{ display: 'grid', gap: '30px' }}>
                        <h5 className="text-center">
                            <strong style={{ display: 'flex', justifyContent: 'center', fontSize: '25px' }}>अधिनस्त कार्यालये</strong>
                        </h5>
                        <div style={{ display: 'flex', gap: '50px', justifyContent: 'center' }}>
                            <div >
                                <a href="/mfs">
                                    <img
                                        src={mfs}
                                        alt="" style={{ width: '10rem' }}
                                    />
                                </a>
                                <br />
                                <strong>अग्निशमन विभाग</strong>
                            </div>
                            <div style={{ paddingTop: '18px' }}>
                                <img
                                    src={Cidco}
                                    alt="" style={{ width: '10rem' }}
                                />
                                <br />
                                <strong>सिडको (C I D C O)</strong>
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '50px', justifyContent: 'center' }}>
                            <div >
                                <a href="/dtp">
                                    <img
                                        src={maharashtra}
                                        alt="" style={{ width: '10rem' }} />
                                </a>
                                <br />
                                <a href="/dtp">
                                    <strong>नगररचना विभाग</strong>
                                </a>
                            </div>
                            <div >
                                <a href="/dma">
                                    <img
                                        src={maharashtra}
                                        alt="" style={{ width: '10rem' }} />
                                </a>
                                <br />
                                <a href="/dma">
                                    <strong>नगरपरिषद संचालनालय</strong>
                                </a>
                            </div>
                        </div>
                        <h5 style={{ display: 'flex', justifyContent: 'center', fontSize: '25px' }}>प्रमुख नगर विकास प्राधिकरण</h5>
                        <div style={{ display: 'flex', gap: '50px', justifyContent: 'center' }}>
                            <div >
                                <a href="/dtp">
                                    <img
                                        src={NMMRDA111}
                                        alt="" style={{ width: '10rem' }} />
                                </a>
                                <br />
                                <a href="/dtp" style={{ textDecoration: 'none' }}>
                                    <strong style={{ display: 'flex', justifyContent: 'center', color: 'black' }}>मुंबई महानगर<br /> विकास प्राधिकरण</strong>
                                </a>
                            </div>
                            <div >
                                <a href="/dma">
                                    <img
                                        src={NMMRDA}
                                        alt="" style={{ width: '10rem' }} />
                                </a>
                                <br />
                                <a href="/dma" style={{ textDecoration: 'none' }}>
                                    <strong style={{ display: 'flex', justifyContent: 'center', color: 'black' }}>नाशिक महानगर<br /> विकास प्राधिकरण </strong>
                                </a>
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '50px', justifyContent: 'center' }}>
                            <div >
                                <a href="/dtp">
                                    <img
                                        src={NNgMRDA}
                                        alt="" style={{ width: '10rem' }} />
                                </a>
                                <br />
                                <a href="/dtp" style={{ textDecoration: 'none' }}>
                                    <strong style={{ display: 'flex', justifyContent: 'center', color: 'black' }}>नागपूर महानगर<br /> विकास प्राधिकरण </strong>
                                </a>
                            </div>
                            <div >
                                <a href="/dma">
                                    <img
                                        src={NPMRDA}
                                        alt="" style={{ width: '10rem' }} />
                                </a>
                                <br />
                                <a href="/dma" style={{ textDecoration: 'none' }}>
                                    <strong style={{ display: 'flex', justifyContent: 'center', color: 'black' }}>पुणे महानगर<br /> विकास प्राधिकरण </strong>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <footer style={{ backgroundColor: "#2f4f4f", padding: "20px 0", textAlign: "center" }}>
                    <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
                        <div style={{ display: "flex", justifyContent: "space-around", flexWrap: "wrap", padding: '4rem 0px' }}>
                            <section>
                                <a href="https://india.gov.in">
                                    <img src={india111} alt="India" width="200" height="150" loading="lazy" />
                                </a>
                            </section>
                            <section>
                                <a href="https://aaplesarkar.maharashtra.gov.in/">
                                    <img src={aaplesarkar} alt="Aaple Sarkar" width="200" height="150" loading="lazy" />
                                </a>
                            </section>
                            <section>
                                <a href="https://digitalindia.gov.in/">
                                    <img src={digitalindia} alt="Digital India" width="200" height="150" loading="lazy" />
                                </a>
                            </section>
                            <section>
                                <a href="https://makeinindia.com">
                                    <img src={makeinindia} alt="Make in India" width="200" height="150" loading="lazy" />
                                </a>
                            </section>
                        </div>

                        <div style={{ marginTop: "20px", borderTop: "1px solid #ddd", paddingTop: "10px", fontSize: "14px" }}>
                            <div style={{ display: "flex", justifyContent: "end", flexWrap: "wrap" }}>
                                <div style={{ fontSize: '17px', minWidth: "250px", color: '#fffc' }}>
                                    2020 &copy; <a href="https://softmatesystems.com/" style={{ color: '#fffc' }}>All rights reserved by Softmate Systems LLP.</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        </div>


    )
}

export default ContactUS
